// extracted by mini-css-extract-plugin
export default {"root":"OlympDataCardsContainer_root__azR+J","listItem":"OlympDataCardsContainer_listItem__5vMaI"};